<template>
  <div class="document-viewer-container">
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="height: 100vh;"
    >
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem;"
      />
      <span class="ml-2">Loading document...</span>
    </div>

    <div
      v-else-if="error"
      class="d-flex flex-column justify-content-center align-items-center"
      style="height: 100vh;"
    >
      <feather-icon
        icon="AlertCircleIcon"
        size="48"
        class="text-danger mb-3"
      />
      <h3 class="text-danger">
        {{ error }}
      </h3>
      <p class="text-muted">
        {{ errorMessage }}
      </p>
    </div>

    <div
      v-else-if="pdfUrl"
      class="pdf-container"
    >
      <iframe
        :src="pdfUrl"
        width="100%"
        height="100%"
        frameborder="0"
        title="PDF Document Viewer"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PublicDocumentViewer',
  data() {
    return {
      pdfUrl: null,
      loading: true,
      error: null,
      errorMessage: '',
    }
  },
  mounted() {
    this.loadDocument()
  },
  methods: {
    async loadDocument() {
      const { token } = this.$route.params

      if (!token) {
        this.error = 'Invalid Link'
        this.errorMessage = 'No document token provided. Please check your link.'
        this.loading = false
        return
      }

      try {
        const baseURL = process.env.VUE_APP_BASE_URL || 'http://localhost:8000'
        const response = await axios.get(`${baseURL}/api/public/document/view/${token}`)

        if (response.data && response.data.presigned_url) {
          this.pdfUrl = response.data.presigned_url
        } else {
          throw new Error('Invalid response from server')
        }
      } catch (error) {
        console.error('Error loading document:', error)

        if (error.response && error.response.status === 404) {
          this.error = 'Document Not Found'
          this.errorMessage = 'This link has expired or is invalid. Please request a new viewing link.'
        } else {
          this.error = 'Error Loading Document'
          this.errorMessage = error.response?.data?.detail || 'Unable to load the document. Please try again later.'
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.document-viewer-container {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.pdf-container {
  width: 100%;
  height: 100%;
}

.pdf-container iframe {
  border: none;
}
</style>
